<template>
	<div class="dash-item dash-contact col-md-4 form-horizontal">
		<contact-list
			v-show="listDisp"
			:labels="labels"
      :nowLang="app.nowLang"
			:getContact="getContact"
      :searchParams="searchParams"
      :receivedContactsInfiniteLoading="receivedContactsInfiniteLoading"
			:toggle="toggle"
      :receivedMultiSelect="receivedMultiSelect"
      :pcDisp="pcDisp"
      :postContactFavorite="postContactFavorite"
      :triggerContactInfiniteBool="triggerContactInfiniteBool"
      :triggerResetBool="triggerResetBool"
      @disableTriggerResetBool="triggerResetBool = false"
      :baseURL="baseURL"
      />
		<contact-search
			v-show="searchDisp"
			:labels="labels"
      :nowLang="app.nowLang"
			:toggle="toggle"
      :fullname="fullname"
      :company="company"
      :position="position"
      :pcDisp="pcDisp"
      v-model="searchParams"
      @enableTriggerResetBool="triggerResetBool = true"
      />
		<contact-detail
			v-show="detailDisp"
			:labels="labels"
      :nowLang="app.nowLang"
			:contact="contact"
			:toggle="toggle"
      :pcDisp="pcDisp"
      :postContactFavorite="postContactFavorite"
      :baseURL="baseURL"
      />
	</div>
</template>

<script>
import contactSearch from 'components/contact/contactSearch'
import contactList from 'components/contact/contactList'
import contactDetail from 'components/contact/contactDetail'
import * as types from 'store/modules/contact/mutation-types'
import { mapGetters, mapActions } from 'vuex'
import env from 'src/../env.js'

export default {
  name: 'contact',
  data () {
    return {
      store: this.$store,
      app: this.$parent.$parent.$parent.$parent,
      labels: {
        en: {
          contactLabel: 'Employee Directory',
          searchLabel: 'Contact Search',
          search: 'Search',
          call: 'Call',
          mail: 'Mail',
          work: 'Work',
          mobile: 'Mobile',
          email: 'E-mail'
        },
        th: {
          contactLabel: 'รายชื่อผู้ติดต่อ',
          searchLabel: 'ค้นหาพนักงาน',
          search: 'ค้นหา',
          call: 'โทร',
          mail: 'ส่งเมล',
          work: 'เบอร์ที่ทำงาน',
          mobile: 'เบอร์มือถือ',
          email: 'อีเมล'
        }
      },
      // contactLabel: 'รายชื่อผู้ติดต่อ',
      // searchLabel: 'ค้นหาพนักงาน',
      listDisp: true,
      searchDisp: false,
      detailDisp: false,
      params: {},
      contact: {},
      triggerResetBool: false,
      searchParams: {
        p_desc_codempid: '',
        p_desc_codcomp: '',
        p_desc_codpos: '',
        p_first_load: 'Y'
      },
      baseURL: window.localStorage.getItem(env.site + '_baseURL') + 'file_uploads/'
    }
  },
  props: [ 'pcDisp', 'triggerContactInfiniteBool' ],
  computed: {
    ...mapGetters({
      contacts: types.GET_CONTACTS,
      fullname: types.GET_FULLNAME,
      company: types.GET_COMPANY,
      position: types.GET_POSITION
    })
  },
  methods: {
    toggle (page) {
      this.searchDisp = false
      this.listDisp = false
      this.detailDisp = false
      switch (page) {
        case 'search':
          this.searchDisp = true
          break
        case 'list':
          this.listDisp = true
          break
        case 'detail':
          this.detailDisp = true
          break
        default:
          this.listDisp = true
          break
      }
    },
    getContact (contact) {
      this.contact = contact
      this.toggle('detail')
    },
    receivedMultiSelect () {
      // this.$store.dispatch(types.RECEIVED_FULLNAMES)
      // this.$store.dispatch(types.RECEIVED_COMPANIES)
      // this.$store.dispatch(types.RECEIVED_POSITIONS)
      this.toggle('search')
    },
    ...mapActions({
      receivedContactsInfiniteLoading: types.RECEIVED_CONTACTS_INFINITE_LOADING,
      postContactFavorite: types.POST_CONTACT_FAVORITE
    })
  },
  components: {
    contactSearch,
    contactList,
    contactDetail
  }
}
</script>

<style src="./style.scss" lang='scss'></style>



// WEBPACK FOOTER //
// component.vue?4f891145